function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 600h600V0H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.085 5.085 0 01-2.545-4.407v-48.666c0-1.818.969-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.088 5.088 0 01-5.088 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M195.4 292.914a5.09 5.09 0 011.497-1.317l36.143-20.874 6.017-3.46a5.127 5.127 0 012.936-.665c.337.028.673.09 1.001.185l44.43 81.357a5.06 5.06 0 01-1.181.938l-27.588 15.925-14.579 8.39c-.417.24-.864.413-1.323.526z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.087 5.087 0 01-2.545-4.407v-48.666c0-1.818.97-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.09 5.09 0 01-5.088 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "M237.627 382.331l-.58-.331h.774z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "M241.065 374.048a5.072 5.072 0 01-2.033-.655l-42.014-24.245 45.293-82.513a5.081 5.081 0 011.81.628l42.124 24.334a5.096 5.096 0 012.458 3.477l-46.178 78.89a5.295 5.295 0 01-1.035.102c-.142 0-.284-.006-.425-.018"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__k"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.087 5.087 0 01-2.545-4.407v-48.666c0-1.818.97-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.09 5.09 0 01-5.088 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__l"
}, /*#__PURE__*/React.createElement("path", {
  d: "M290.279 292.38l-.279.477v-.639z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__n"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.087 5.087 0 01-2.545-4.407v-48.666c0-1.818.97-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.09 5.09 0 01-5.088 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__o"
}, /*#__PURE__*/React.createElement("path", {
  d: "M286.351 291.597l-42.177-24.333a5.084 5.084 0 00-1.861-.633l.84-1.53L290 292.218v.639l-1.158 1.979c-.347-1.348-1.263-2.528-2.491-3.239"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__q"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.087 5.087 0 01-2.545-4.407v-48.666c0-1.818.97-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.09 5.09 0 01-5.088 0"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "nodejs_svg__r"
}, /*#__PURE__*/React.createElement("path", {
  d: "M286.351 291.597l-42.177-24.333a5.084 5.084 0 00-1.861-.633l.84-1.53L290 292.218v.639l-1.158 1.979c-.347-1.348-1.263-2.528-2.491-3.239"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "scale(-86.48019 86.48019) rotate(-63.886 1.799 4.453)",
  spreadMethod: "pad",
  id: "nodejs_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#83a178"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "scale(132.79816 -132.79816) rotate(-36.459 -2.712 -3.873)",
  spreadMethod: "pad",
  id: "nodejs_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.138,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.697,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.908,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9bb48f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(97.417 0 0 -97.417 192.862 382.166)",
  spreadMethod: "pad",
  id: "nodejs_svg__h"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#687e67"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(97.417 0 0 -97.417 192.862 320.348)",
  spreadMethod: "pad",
  id: "nodejs_svg__j"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#687e67"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(97.417 0 0 -97.417 192.862 292.538)",
  spreadMethod: "pad",
  id: "nodejs_svg__m"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#687e67"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(97.417 0 0 -97.417 192.862 279.968)",
  spreadMethod: "pad",
  id: "nodejs_svg__p"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.092,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303,
  stopColor: "#9bb48f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.862,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#687e67"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "scale(-136.49806 136.49806) rotate(-63.886 .986 3.099)",
  spreadMethod: "pad",
  id: "nodejs_svg__s"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#687e67"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#83a178"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M296.953 165.056c-1.46 0-2.912.38-4.19 1.12l-13.338 7.893c-1.99 1.114-1.019 1.509-.362 1.738 2.657.922 3.195 1.135 6.031 2.743.295.167.687.103.992-.076l10.247-6.083c.371-.206.895-.206 1.237 0l39.95 23.058c.372.212.61.64.61 1.08v46.105c0 .45-.238.872-.62 1.1l-39.933 23.039a1.25 1.25 0 01-1.23 0l-39.924-23.045a1.285 1.285 0 01-.634-1.094V196.53c0-.441.246-.86.63-1.068l10.944-6.323c5.938-2.97 9.574.528 9.574 4.04v45.52c0 .644.517 1.15 1.161 1.15h5.065c.634 0 1.158-.506 1.158-1.15v-45.52c0-7.924-4.316-12.47-11.829-12.47-2.309 0-4.127 0-9.202 2.502l-10.476 6.03a8.437 8.437 0 00-4.19 7.289v46.104c0 2.995 1.602 5.792 4.19 7.28L292.764 273c2.527 1.429 5.887 1.429 8.395 0l39.947-23.085a8.434 8.434 0 004.196-7.281V196.53a8.457 8.457 0 00-4.196-7.288l-39.947-23.065a8.375 8.375 0 00-4.206-1.121",
  fill: "#689f63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.293 196.818c-17.482 0-21.144 8.024-21.144 14.755 0 .64.514 1.151 1.154 1.151h5.165c.577 0 1.058-.415 1.148-.978.78-5.258 3.105-7.912 13.677-7.912 8.416 0 12 1.904 12 6.37 0 2.573-1.017 4.484-14.096 5.765-10.93 1.081-17.692 3.496-17.692 12.24 0 8.061 6.794 12.868 18.186 12.868 12.798 0 19.131-4.442 19.933-13.972a1.17 1.17 0 00-.305-.889 1.178 1.178 0 00-.846-.369h-5.185a1.15 1.15 0 00-1.12.903c-1.245 5.533-4.27 7.301-12.477 7.301-9.189 0-10.257-3.2-10.257-5.6 0-2.906 1.26-3.75 13.667-5.393 12.277-1.623 18.11-3.92 18.11-12.55 0-8.704-7.259-13.69-19.918-13.69M357.939 245.7h1.343c1.098 0 1.304.773 1.304 1.22 0 1.184-.816 1.184-1.264 1.184h-1.383zm-1.632 3.789h2.975c1.019 0 3.016 0 3.016-2.283 0-1.59-1.02-1.914-1.632-2.118 1.184-.081 1.264-.856 1.426-1.955.083-.692.206-1.875.448-2.281h-1.831c-.043.406-.33 2.607-.33 2.728-.118.49-.284.733-.894.733h-1.506v-3.461h-1.672zm-3.563-4.298c0-3.586 2.893-6.48 6.436-6.48 3.586 0 6.478 2.955 6.478 6.48 0 3.584-2.932 6.436-6.478 6.436-3.503 0-6.436-2.81-6.436-6.436m14.155-.022c0-4.236-3.464-7.7-7.7-7.7-4.196 0-7.7 3.423-7.7 7.7 0 4.359 3.587 7.7 7.7 7.7 4.157 0 7.7-3.341 7.7-7.7",
  fill: "#689f63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.243 345.433a5.108 5.108 0 01-2.558 4.445l-42.355 24.375a4.977 4.977 0 01-2.331.674h-.438a5.052 5.052 0 01-2.34-.674l-42.354-24.375a5.132 5.132 0 01-2.561-4.445l.093-65.635c0-.913.474-1.762 1.277-2.21a2.461 2.461 0 012.54 0l25.173 14.414c1.592.945 2.56 2.614 2.56 4.439v30.664c0 1.828.969 3.52 2.555 4.429l10.718 6.173a5.092 5.092 0 002.564.687c.873 0 1.768-.226 2.544-.687l10.715-6.173a5.1 5.1 0 002.558-4.43v-30.663c0-1.825.982-3.504 2.564-4.44l25.165-14.413a2.49 2.49 0 012.557 0 2.556 2.556 0 011.27 2.21zM373.11 311.257c0-.456-.245-.88-.64-1.106l-14.549-8.386a1.282 1.282 0 00-1.277 0l-14.548 8.386c-.397.227-.64.65-.64 1.106v16.799c0 .456.243.879.64 1.108l14.546 8.402a1.28 1.28 0 001.281 0l14.547-8.402c.395-.23.64-.652.64-1.108zm3.93 124.403a2.56 2.56 0 01-3.805-2.235v-65a1.79 1.79 0 00-2.685-1.551l-10.609 6.112a5.115 5.115 0 01-5.112-.001l-42.37-24.453a5.115 5.115 0 01-2.56-4.431v-48.916c0-1.828.975-3.516 2.557-4.432l42.37-24.471a5.12 5.12 0 015.118 0l42.377 24.47a5.122 5.122 0 012.558 4.433V417.12a5.118 5.118 0 01-2.624 4.468zM518.131 328.495a5.116 5.116 0 012.546 4.424v11.854c0 1.823-.97 3.51-2.548 4.425l-42.099 24.443a5.117 5.117 0 01-5.127.007l-42.356-24.453a5.115 5.115 0 01-2.558-4.43v-48.903c0-1.84.987-3.537 2.584-4.446l42.093-23.985a5.112 5.112 0 015.017-.028l25.46 14.151a2.557 2.557 0 01.032 4.455l-42.625 24.465a2.559 2.559 0 00-1.286 2.219v15.326c0 .914.488 1.76 1.281 2.216l13.266 7.648a2.555 2.555 0 002.554 0l13.272-7.648a2.556 2.556 0 001.28-2.216v-12.058a2.56 2.56 0 013.844-2.213z",
  fill: "#333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472.842 330.786a.98.98 0 00.982 0l8.13-4.69a.983.983 0 00.491-.851v-9.388a.982.982 0 00-.49-.851l-8.13-4.691a.98.98 0 00-.983 0l-8.124 4.69a.982.982 0 00-.49.852v9.388c0 .35.186.675.49.85z",
  fill: "#689f63",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__b)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M239.032 373.393l-42.134-24.315a5.085 5.085 0 01-2.545-4.407v-48.666c0-1.818.969-3.497 2.544-4.408l42.133-24.334a5.093 5.093 0 015.091 0l42.124 24.334a5.093 5.093 0 012.543 4.408v48.668a5.084 5.084 0 01-2.545 4.405l-42.123 24.315a5.088 5.088 0 01-5.088 0",
  fill: "url(#nodejs_svg__c)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__d)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M195.4 292.914a5.09 5.09 0 011.497-1.317l36.143-20.874 6.017-3.46a5.127 5.127 0 012.936-.665c.337.028.673.09 1.001.185l44.43 81.357a5.06 5.06 0 01-1.181.938l-27.588 15.925-14.579 8.39c-.417.24-.864.413-1.323.526z",
  fill: "url(#nodejs_svg__e)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__f)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M237.627 382.331l-.58-.331h.774z",
  fill: "url(#nodejs_svg__h)"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__i)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M241.065 374.048a5.072 5.072 0 01-2.033-.655l-42.014-24.245 45.293-82.513a5.081 5.081 0 011.81.628l42.124 24.334a5.096 5.096 0 012.458 3.477l-46.178 78.89a5.295 5.295 0 01-1.035.102c-.142 0-.284-.006-.425-.018",
  fill: "url(#nodejs_svg__j)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__k)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M290.279 292.38l-.279.477v-.639z",
  fill: "url(#nodejs_svg__m)"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__n)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__o)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M286.351 291.597l-42.177-24.333a5.084 5.084 0 00-1.861-.633l.84-1.53L290 292.218v.639l-1.158 1.979c-.347-1.348-1.263-2.528-2.491-3.239",
  fill: "url(#nodejs_svg__p)"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__q)",
  transform: "matrix(1.33333 0 0 -1.33333 -104.408 581.31)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#nodejs_svg__r)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M286.351 291.597l-42.177-24.333a5.084 5.084 0 00-1.861-.633l.84-1.53L290 292.218v.639l-1.158 1.979c-.347-1.348-1.263-2.528-2.491-3.239",
  fill: "url(#nodejs_svg__s)"
})));

function SvgNodejs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 589.828 361.237"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default __webpack_public_path__ + "static/nodejs.5b7584ff.svg";
export { SvgNodejs as ReactComponent };